import { WorkloadStatus } from './types';

export const toNamespaceOptions = (response: any) => {
  return (
    response.items?.map((item) => ({
      label: item.metadata.name,
      value: item.metadata.name,
    })) || []
  );
};

/** 判断工作负载状态 */
export const getWorkloadStatus = ({
  readyReplicas,
  replicas,
}: {
  readyReplicas?: number;
  replicas?: number;
}): WorkloadStatus => {
  if (readyReplicas === 0 && replicas === 0) {
    return 'Stopped';
  }
  if (readyReplicas === replicas && !!replicas && !!readyReplicas) {
    return 'Running';
  }
  return 'Updating';
};
